// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"701726cf","317":"cc85984c","900":"762cdc00"}[chunkId] + ".chunk.js";
};